import React from "react";
import { TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

function TableHeader(props) {
  const {
    valueToOrderBy,
    orderDirection,
    handleRequestSort,
    onSelectAllClick,
    numSelected,
    rowCount,
    columnForm,
  } = props;

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all desserts",
            }}
          />
        </TableCell>
        {columnForm.serial_number === true && (
          <TableCell key="serial_number">
            <TableSortLabel
              active={valueToOrderBy === "serial_number"}
              direction={
                valueToOrderBy == "serial_number" ? orderDirection : "asc"
              }
              onClick={createSortHandler("serial_number")}
            >
              <strong>Serial Number</strong>
            </TableSortLabel>
          </TableCell>
        )}
        {columnForm.battery === true && (
          <TableCell align="center" key="battery">
            <TableSortLabel
              active={valueToOrderBy === "battery"}
              direction={valueToOrderBy == "battery" ? orderDirection : "asc"}
              onClick={createSortHandler("battery")}
            >
              <strong>Battery</strong>
            </TableSortLabel>
          </TableCell>
        )}
        {columnForm.battery_status === true && (
          <TableCell align="center" key="battery_status">
            <TableSortLabel
              active={valueToOrderBy === "battery_status"}
              direction={
                valueToOrderBy == "battery_status" ? orderDirection : "asc"
              }
              onClick={createSortHandler("battery_status")}
            >
              <strong>Battery status</strong>
            </TableSortLabel>
          </TableCell>
        )}
        {columnForm.battery_temp === true && (
          <TableCell align="center" key="battery_temp">
            <TableSortLabel
              active={valueToOrderBy === "battery_temp"}
              direction={
                valueToOrderBy == "battery_temp" ? orderDirection : "asc"
              }
              onClick={createSortHandler("battery_temp")}
            >
              <strong>Battery Temperature</strong>
            </TableSortLabel>
          </TableCell>
        )}
        {columnForm.wifi === true && (
          <TableCell key="wifi" align="center">
            <TableSortLabel
              active={valueToOrderBy === "wifi"}
              direction={valueToOrderBy == "wifi" ? orderDirection : "asc"}
              onClick={createSortHandler("wifi")}
            >
              <strong>WIFI</strong>
            </TableSortLabel>
          </TableCell>
        )}
        {columnForm.cart === true && (
          <TableCell key="cart" align="center">
            <TableSortLabel
              active={valueToOrderBy === "type"}
              direction={valueToOrderBy == "type" ? orderDirection : "asc"}
              onClick={createSortHandler("type")}
            >
              <strong>Status + Floor</strong>
            </TableSortLabel>
          </TableCell>
        )}
        {columnForm.tablet_status === true && (
          <TableCell key="status" align="center">
            <TableSortLabel
              active={valueToOrderBy === "status"}
              direction={valueToOrderBy == "status" ? orderDirection : "asc"}
              onClick={createSortHandler("status")}
            >
              <strong>Tablet Status</strong>
            </TableSortLabel>
          </TableCell>
        )}

        {columnForm.location_update === true && (
          <TableCell align="center" key="ts">
            <TableSortLabel
              active={valueToOrderBy === "ts"}
              direction={valueToOrderBy == "ts" ? orderDirection : "asc"}
              onClick={createSortHandler("ts")}
            >
              <strong>Location Update</strong>
            </TableSortLabel>
          </TableCell>
        )}

        {columnForm.photo === true && (
          <TableCell align="center">
            <strong>Photo</strong>
          </TableCell>
        )}
        {columnForm.show_location === true && (
          <TableCell align="center">
            <strong>Show Location</strong>
          </TableCell>
        )}
        {columnForm.swan_song === true && (
          <TableCell align="center">
            <strong>Swan Song</strong>
          </TableCell>
        )}
        {columnForm.beacon === true && (
          <TableCell align="center">
            <strong>Beacon</strong>
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  );
}

export default TableHeader;
